import React from 'react';
import styles from './RichText.module.scss';

export interface RichTextProps {
  anchorTag?: string;
  moduleClass?: string;
  richTextAsHtml?: string; // server-provided sanitized HTML
}

export const RichText: React.FC<RichTextProps> = ({
  anchorTag,
  moduleClass = '',
  richTextAsHtml,
}) => {
  if (!richTextAsHtml) {
    return null;
  }

  return (
    <section
      {...(anchorTag ? { id: anchorTag } : {})}
      className={`module-richtext ${styles['rich-text-container']} ${moduleClass}`}
    >
      <div
        className="Richtext_module-base"
        dangerouslySetInnerHTML={{
          __html: richTextAsHtml,
        }}
        suppressHydrationWarning={true}
      />
    </section>
  );
};
